/*
 * Studio X motion: two curves, one dim level, one reveal threshold.
 * Values mirror schmitt-design/languages/studio-x/tokens.css.
 */
export type Bezier = [number, number, number, number];

/** "drift": the default curve, barely overshoots (CSS: --sd-ease-primary) */
export const EASE_DRIFT: Bezier = [0.65, 0, 0, 1.04];

/** "wipe": slideshow / loader wipes (CSS: --sd-ease-signature) */
export const EASE_WIPE: Bezier = [0.6, 0.08, 0.02, 0.99];

/** Gentle ease-out for scroll fade-ins (CSS: --sd-ease-out) */
export const EASE_OUT: Bezier = [0.25, 0.46, 0.45, 0.94];

/** Elements enter when their top reaches 85% of the viewport height, once. */
export const REVEAL_VIEWPORT = { once: true, margin: '0px 0px -15% 0px' } as const;
